import React from "react";
import PropTypes from "prop-types";
import TownGalleryFilterBar from "../TownGalleryFilterBar";
import TownGalleryItems from "../TownGalleryItems";

const TownGallery = (props) => {
  return (
    <div className="bg-sgbc-yellow-200 py-6 md:px-10 w-full rounded-2xl ">
      <TownGalleryFilterBar />
      <TownGalleryItems />
    </div>
  );
};

TownGallery.propTypes = {};

export default TownGallery;
